<template>
	<keep-alive>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				任务列表
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
			<!-- <el-form-item>
						<el-button  type="primary" v-if="$hasPermission('plat:plattaskaccept:accept')" @click="batchAccpetTask">接收任务</el-button>
					</el-form-item>
			<el-form-item>
						<el-button  class="refreshBtn" v-if="$hasPermission('plat:plattaskaccept:cancel')" @click="batchCancelTask">取消任务</el-button>
					</el-form-item>
			<el-form-item>
						<el-button  class="refreshBtn" v-if="$hasPermission('plat:plattaskaccept:close')" @click="batchCloseTask">关闭任务</el-button>
					</el-form-item> -->
					<el-form-item>
						<el-button class="exportBtn" style="left: 615px;" v-if="$hasPermission('plat:plattaskaccept:export')" type="info" @click="exportHandle()">
							{{ $t('export') }}
						</el-button>
					</el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button></el-form-item>
					<!-- <el-form-item>
						<el-button class="delBtn" style="left: 760px;" v-if="$hasPermission('plat:plattaskaccept:delete')" type="danger" @click="deleteHandle()">
							{{ $t('deleteBatch') }}
						</el-button>
					</el-form-item> -->
				</el-form>
			</el-col>
		</el-row>
	  <div class="mod-plat__plattaskaccept">
		<el-form  style="padding:10px 5px 0px;" :label-width="'140px'" :model="dataForm" ref="loginFormRef" @keyup.enter.native="getDataList()">
				  <el-row>
					<el-col :md="8" :lg="8">
							<el-form-item label="任务发布编号:" prop="taskCode">
								<el-input style="width: 100%;" v-model="dataForm.taskCode" placeholder="任务发布编号" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="8" :lg="8">
						<el-form-item label="审核状态:" prop="status">
							<el-select style="width: 100%;" v-model="dataForm.status" @change="handleClick" placeholder="审核状态" clearable filterable>
								<el-option v-for="item in optionsvalue" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="8" :lg="8">
						<el-form-item label="税源地:" prop="bodyId">
							<el-select v-model="dataForm.bodyId" placeholder="请选择" style="width:100%" clearable filterable>
							<el-option
								v-for="item in bodyPageList"
								:key="item.id"
								:label="`${item.bodyName}-${item.abbreviation}`"
								:value="item.id">
							</el-option>
							</el-select>
						</el-form-item>
					  </el-col>
					  <el-col :md="8" :lg="8">
						  <el-form-item label-width="100px" label="发布方:" ><el-input style="width: 100%;" v-model="dataForm.publishName" placeholder="请输入发布方" clearable></el-input></el-form-item>
					  </el-col>
					  <el-col :sm="8" :lg="8">
						<el-form-item class="pickerStyle" label="发布时间:">
							<el-date-picker style="width:48%" :picker-options='pickerStartOptions(dataForm.endDate)' v-model="dataForm.startDate" placeholder="开始时间" type="date" @change="formatStartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
							<span style="width:4%;text-align: center;display: inline-block;">~</span>
							<el-date-picker style="width:48%" v-model="dataForm.endDate" :picker-options='pickerEndOptions(dataForm.startDate)' placeholder="结束时间"  type="date" @change="formatEndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<!-- <el-col :md="8" :lg="6">
						  <el-form-item label="接收方:" ><el-input style="width: 100%;" v-model="dataForm.realName" placeholder="请输入接收方" clearable></el-input></el-form-item>
					  </el-col> -->
					  <el-col :md="8" :lg="8">
						  <el-form-item label-width="0px">
							  <div style="text-align: right;">
								  <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
								  <el-button type="info" @click="resetLoginForm">重置</el-button>
							  </div>
  
						  </el-form-item>
					  </el-col>
				  </el-row>
			  </el-form>
		<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" height="100%">
		  <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
		  <el-table-column label="序号" type="index" width="50" align="center">
			<template slot-scope="scope">
			  <span>{{(page - 1) * limit + scope.$index + 1}}</span>
			</template>
		  </el-table-column>
		  <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center" width="200">
			<!-- <template slot-scope="scope">
			  <el-button type="text" size="small">{{scope.row.taskCode}}</el-button>
			</template> -->
		  </el-table-column>
		  <!-- @click="infoHandle(scope.row.id)" -->
		  
		   
		  <el-table-column prop="publishName" label="发布方" header-align="center" align="center"></el-table-column>
		  <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column>
		  <el-table-column prop="contractCode" label="关联合同编号" header-align="center" align="center" width="200">
				<template slot-scope="scope">
					<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="contractinfoHandle(scope.row)">{{scope.row.contractCode}}</el-button>
				</template>
			</el-table-column>	
		  <!-- <el-table-column prop="assignee" label="被分配方" header-align="center" align="center"></el-table-column> -->
		  <el-table-column prop="taskType" label="任务大类" header-align="center" align="center" width="200">
			<template slot-scope="scope">
			  {{ $getDictLabel("taskType", scope.row.taskType) }}
			</template>
		  </el-table-column>
		  <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
			<template slot-scope="scope">
				<span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
			</template>
			</el-table-column>
		  <el-table-column prop="createDate" label="发布时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>

		  <el-table-column prop="status" label="审核状态" header-align="center" align="center" show-overflow-tooltip>
			<template slot-scope="scope">
				<!-- {{ $getDictLabel("acceptTaskStatus", scope.row.status) }} -->
				{{scope.row.status == 0 ? '已保存' : scope.row.status == 1 ? '待审核' : scope.row.status == 2 ? '审核通过' : '已关闭'}}
			</template>
		  </el-table-column>
		  <!-- <el-table-column  v-if="(($hasPermission('plat:plattaskaccept:audit')) || ($hasPermission('plat:plattaskaccept:delete'))) && cookieAdminName == 'OPERATE'" prop="acceptDate" label="操作" header-align="center" align="center">
			<template slot-scope="scope">
				<span :disable="scope.row.status!=5" v-if="$hasPermission('plat:plattaskaccept:delete')" @click="delTask(scope.row.id)" style="margin-right:8px;color:#EF2323;cursor: pointer;">删除</span>
			</template>
		  </el-table-column> -->
		  <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
					<template slot-scope="scope">
								<el-button
									v-if="$hasPermission('plat:plattask:update') && cookieAdminName == 'OPERATE'"
									:disabled="scope.row.status != 0 &&  scope.row.status != 2"
									type="text"
									size="small"
									@click="childHandle(scope.row.id)"
								>
									{{ $t('update') }}
								</el-button>
						<el-tooltip class="item" v-if="$hasPermission('plat:plattask:update') && cookieAdminName != 'OPERATE'" content="只有草稿状态才可修改。如已提交发布，请先进行驳回操作！"  effect="dark"  placement="left">
								<el-button
									:disabled="scope.row.status != 0"
									type="text"
									size="small"
									@click="childHandle(scope.row.id)"
								>
									{{ $t('update') }}
								</el-button>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="只有草稿状态才可删除。如已提交发布，请先进行驳回操作！" placement="left">
							<span>
								<el-button
									v-if="$hasPermission('plat:plattask:delete')"
									:disabled="scope.row.status != 0"
									type="text"
									size="small"
									@click="deleteHandle(scope.row.id)"
								>
									{{ $t('delete') }}
								</el-button>
							</span>
						</el-tooltip>
						<el-tooltip class="item" v-if="scope.row.status < 2" effect="dark" content="在详情页面中进行审核！" placement="left">
							<el-button type="text" size="small" @click="infoHandle(scope.row.id)">详情</el-button>
						</el-tooltip>
						<el-tooltip class="item" v-else effect="dark" content="查看详情" placement="left">
							<el-button type="text" size="small" @click="infoHandle(scope.row.id)">详情</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
		</el-table>
		<el-pagination
			background
		  :current-page="page"
		  :page-sizes="[10, 20, 50, 100, 400]"
		  :page-size="limit"
		  :total="total"
		  layout="total, sizes, prev, pager, next, jumper"
		  @size-change="pageSizeChangeHandle"
		  @current-change="pageCurrentChangeHandle">
		</el-pagination>
		<!-- 弹窗, 新增 / 修改 -->
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		<!--上传文件弹窗-->
		<el-dialog :title="uploadType == 1 ? '凭证' : '验收证明'" v-if="uploadDialog" :visible.sync="uploadDialog" :before-close="uploadDiaClose" >
		  <div class="el-upload-list-wrap-my">
			<el-upload
			  action=""
			  accept="image/*,application/pdf,application/zip"
			  :disabled="uploadFileItem?!(uploadFileItem.status == 1 || uploadFileItem.status == 2 || uploadFileItem.status == 7 || uploadFileItem.status == 8):false"
			  list-type="picture-card"
			  :file-list="fileList"
			  :http-request="fileUpload"
			  :class="{imgHide:uploadFileItem?!(uploadFileItem.status == 1 || uploadFileItem.status == 2 || uploadFileItem.status == 7 || uploadFileItem.status == 8):false}"
			  >
			  <i slot="default" class="el-icon-plus"></i>
			  <div slot="file"  slot-scope="{file}">
				<img
				  v-if="showPdf(file.url)"
				  class="el-upload-list__item-thumbnail"
				  src="../../../assets/img/pdf.png" alt=""
				>
				<img
				  v-else-if="showZip(file.url)"
				  class="el-upload-list__item-thumbnail"
				  src="../../../assets/img/zip.jpg" alt=""
				>
				<img
				  v-else
				  class="el-upload-list__item-thumbnail"
				  :src="file.url" alt=""
				>
				<span class="el-upload-list__item-actions">
				  <span
					v-if="showPdf(file.url)"
					class="el-upload-list__item-preview"
					@click="pdfPreview(file.url)"
				  >
					<i class="el-icon-zoom-in"></i>
				  </span>
				  <span
					v-else-if="showZip(file.url)"
					class="el-upload-list__item-preview"
					@click="zipPreview(file.url)"
				  >
					<i class="el-icon-download"></i>
				  </span>
				  <span
					v-else
					class="el-upload-list__item-preview"
					@click="handlePictureCardPreview(file)"
				  >
					<i class="el-icon-zoom-in"></i>
				  </span>
				  <span
					v-if="uploadFileItem?(uploadFileItem.status == 1 || uploadFileItem.status == 2 || uploadFileItem.status == 7 || uploadFileItem.status == 8):true"
					class="el-upload-list__item-delete"
					@click="handleRemove(file)"
				  >
					<i class="el-icon-delete"></i>
				  </span>
				</span>
			  </div>
			  <span slot="tip" class="uploadimgage">上传仅支持图片、PDF、zip文件</span>
			</el-upload>
			
			<el-dialog :visible.sync="previewPicDialog" append-to-body>
			  <img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		  </div>
		  
		  <span slot="footer" class="dialog-footer">
			<!-- 添加一个按钮权限：plat:taskAccept:uploadBtn 2021-05-14 -->
			<el-button type="primary"  v-if="$hasPermission('plat:taskAccept:uploadBtn') && uploadFileItem?(uploadFileItem.status == 1 || uploadFileItem.status == 2 || uploadFileItem.status == 7 || uploadFileItem.status == 8):true" @click="fileBindTask">确 定</el-button>
			<el-button @click="uploadClose">取 消</el-button>
		  </span>
		</el-dialog>
		<!--审核文件弹窗-->
		<el-dialog title="审核" :visible.sync="auditDia" width="527px" @close="auditDiaCancel">
		  <el-form  label-width="40px">
			<el-row type="flex" justify="space-between" v-for="item in auditDiaItemList" :key="item.name">
			  <el-col :span="10">
				<el-form-item  label="姓名"><el-input style="width: 100%;" disabled v-model="item.name"></el-input></el-form-item>
			  </el-col>
			  <el-col :span="10">
				<el-form-item  label="金额"><el-input style="width: 100%;" disabled v-model="item.money"></el-input></el-form-item>
			  </el-col>
			</el-row>
			<el-form-item label="备注">
			  <el-input type="textarea" :autosize="{ minRows: 2}" placeholder="请输入备注" v-model="auditFormData.reason"></el-input>
			</el-form-item>
			<div style="textAlign:right;">合计结算金额：{{allAduitMoney}}</div>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
			<el-button v-no-more-click type="primary" @click="batchAuditTask('pass')">确 定</el-button>
			<el-button v-no-more-click @click="batchAuditTask('')">不通过</el-button>
		  </span>
		</el-dialog>
	  </div>
	</el-card>
</keep-alive>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './plattaskaccept-add-or-update'
  import { addDynamicRoute } from '@/router'
  import Cookies from 'js-cookie'
  export default {
	name:'plat-plattask',
	mixins: [mixinViewModule],
	data () {
	  return {
		pickerStartOptions(endTime){
                return {
                    disabledDate(time){
                        if(endTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                        }
                    }
                } 
            },
            pickerEndOptions(startTime){
                return {
                    disabledDate(time){
                        if(startTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                        }
                    }
                }
            },
		optionsvalue: [
			{value:0,label:'已保存'},
			{value:1,label:'待审核'},
			{value:2,label:'审核通过'},
		],
		// options: [{
		//   value: 0,
		//   label: '被分配任务'
		// }, {
		//   value: 1,
		//   label: '批量导入任务'
		// }],
		cookieAdminName:Cookies.get('admin_role'),
		mixinViewModuleOptions: {
			getDataListURL: '/sys/plat/task/page',
			getDataListIsPage: true,
			deleteURL: '/sys/plat/task',
			deleteIsBatch: true,
			exportURL: '/sys/plat/task/export2',
			isBodyPage:true
		},
		dataForm: {
			bodyId:'',
		  id: '',
		  taskCode:'',
		publishName:'',
		  startDate: '',
			endDate: '',
			status:''
		},
		BtnTit:Cookies.get('admin_role')=== 'PERSON'?'批量上传完工证明':'批量上传验收证明',
		uploadDialog:false,
		previewPicDialog:false,
		uploadFileItem:null,
		fileList:[],
		dialogImageUrl:'',
		auditDia:false,
		auditFormData:{
		  reason:'',
		},
		auditDiaItemList:[],
		uploadType:'', // 1 个人证明 2 企业或管理员上传证明 3 企业或管理员批量上传完工证明
	  }
	},
	components: {
	  AddOrUpdate
	},
	computed:{
	  allAduitMoney:function(){
		if(this.auditDiaItemList.length){
		  var num = 0;
		  this.auditDiaItemList.forEach(item=>{
			num+=Number(item.money)
		  })
		  return num.toFixed(2);
		}else{
		  return 0
		}
	  }
	},
	destroyed(){
		console.log('销毁')
	},
	methods: {
		// 查看
		contractinfoHandle (param) {
			console.log(param)
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))

			// if(param.bodyId == '1453241566079012865'){
				// 路由参数
				const routeParams = {
					routeName: `${this.$route.name}__合同详情`,
					title: `合同详情`,
					path: 'plat/platcontract-info',
					params: {
						id: param.contractId
					}
				}
				// 动态路由
				addDynamicRoute(routeParams, this.$router)
			// }else{
			// 	// 路由参数
			// 	const routeParams = {
			// 		routeName: `${this.$route.name}__合同信息`,
			// 		title: `合同信息`,
			// 		path: 'user/contractDetail',
			// 		params: {
			// 			isContractList:true,
			// 			id: param.userId,
			// 		}
			// 	}
			// 	// 动态路由
			// 	addDynamicRoute(routeParams, this.$router)
			// }
			
		},
		formatStartTime (val) {
		  this.dataForm.startDate = val
    },
    formatEndTime (val) {
		  this.dataForm.endDate = val
    },
	handleClick(tab) {
		this.dataForm.status = tab
	  this.getDataList();
	},
	  handleChange(e){
		this.getDataList();
	  },
	  // 子级
	//   childHandle () {
	// 	// 路由参数
	// 	const routeParams = {
	// 	  routeName: `${this.$route.name}__任务列表`,
	// 	  title: `任务列表`,
	// 	  path: 'task/task-list',
	// 	  params: {
	// 		// dictTypeId: row.id
	// 	  }
	// 	}
	// 	// 动态路由
	// 	addDynamicRoute(routeParams, this.$router)
	//   },
	childHandle (id = 0) {
		localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))

		  // 路由参数
		  const routeParams = {
        routeName: `${this.$route.name}__任务信息`,
        title: `任务信息`,
        path: 'plat/platttask-add',
        params: {
			  id: id
        }
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    },
	  //批量接收任务
	  batchAccpetTask(){
		if(!this.dataListSelections.length){
		  this.$message({
			type:'warning',
			message:'请选择需要操作的任务！'
		  })
		  return
		}
		this.$confirm(this.$t('prompt.info', { 'handle': '批量接收任务'}), this.$t('prompt.title'), {
		  confirmButtonText: this.$t('confirm'),
		  cancelButtonText: this.$t('cancel'),
		  type: 'warning'
		}).then(()=>{
		  this.$http.post('/sys/plat/task/accept/accept',this.dataListSelections.map((item)=>{return item.id})).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg)
			}
			this.$message({
				message: this.$t('prompt.success'),
				type: 'success',
				duration: 1500,
				onClose: () => {
				  this.query()
				}
			})
		  })
		})
		
	  },
	  resetLoginForm(){
		this.dataForm.id = '';
		this.dataForm.bodyId = '';
		this.dataForm.publishNam = '';
		this.dataForm.startDate = '';
		this.dataForm.endDate = '';
		this.dataForm.status = '';
		this.dataForm.taskCode = '';
		this.dataForm.publishName = '';
		this.getDataList();
	  },
	  //批量取消任务
	  batchCancelTask(){
		if(!this.dataListSelections.length){
		  this.$message({
			type:'warning',
			message:'请选择需要操作的任务！'
		  })
		  return
		}
		this.$confirm(this.$t('prompt.info', { 'handle': '批量删除任务'}), this.$t('prompt.title'), {
		  confirmButtonText: this.$t('confirm'),
		  cancelButtonText: this.$t('cancel'),
		  type: 'warning'
		}).then(()=>{
		  this.$http.post('/sys/plat/task/accept/cancel',this.dataListSelections.map((item)=>{return item.id})).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg)
			}
			this.$message({
				message: this.$t('prompt.success'),
				type: 'success',
				duration: 1500,
				onClose: () => {
				  this.query()
				}
			})
		  }).catch(()=>{})
		}).catch(()=>{})
	  },
	  //批量完成任务
	  batchCompleteTask(){
		if(!this.dataListSelections.length){
		  this.$message({
			type:'warning',
			message:'请选择需要操作的任务！'
		  })
		  return
		}
		this.$confirm(this.$t('prompt.info', { 'handle': '批量完成任务'}), this.$t('prompt.title'), {
		  confirmButtonText: this.$t('confirm'),
		  cancelButtonText: this.$t('cancel'),
		  type: 'warning'
		}).then(()=>{
		  this.$http.post('/sys/plat/task/accept/complete',this.dataListSelections.map((item)=>{return item.id})).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg)
			}
			this.$message({
				message: this.$t('prompt.success'),
				type: 'success',
				duration: 1500,
				onClose: () => {
				  this.query()
				}
			})
		  }).catch(()=>{})
		}).catch(()=>{})
	  },
	  //批量关闭任务
	  batchCloseTask(){
		if(!this.dataListSelections.length){
		  this.$message({
			type:'warning',
			message:'请选择需要操作的任务！'
		  })
		  return
		}
		this.$confirm(this.$t('prompt.info', { 'handle': '批量关闭任务'}), this.$t('prompt.title'), {
		  confirmButtonText: this.$t('confirm'),
		  cancelButtonText: this.$t('cancel'),
		  type: 'warning'
		}).then(()=>{
		  this.$http.post('/sys/plat/task/accept/close',this.dataListSelections.map((item)=>{return item.id})).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg)
			}
			this.$message({
				message: this.$t('prompt.success'),
				type: 'success',
				duration: 1500,
				onClose: () => {
				  this.query()
				}
			})
		  }).catch(()=>{})
		}).catch(()=>{})
	  },
	  //打开审核弹窗
	  openBatchAuditDia(){
		if(!this.dataListSelections.length){
		  this.$message({
			message: '请选择批量审核的信息！',
			type: 'error',
			duration: 1500,
		  })
		  return
		}
		this.auditDiaItemList = this.dataListSelections.map(item=>{
		  return {
			id:item.id,
			name:item.realName,
			money:item.money
		  }
		})
		this.auditDia = true;
	  },
	   //单个审核
	  openAuditDia(item){
		this.auditDiaItemList = [{
		  id:item.id,
		  name:item.realName,
		  money:item.money
		}];
		this.auditDia = true;
	  },
	  //批量审核接口
	  batchAuditTask(result){
		this.$confirm(this.$t('prompt.info', { 'handle': '审核任务'}), this.$t('prompt.title'), {
		  confirmButtonText: this.$t('confirm'),
		  cancelButtonText: this.$t('cancel'),
		  type: 'warning'
		}).then(()=>{
		  this.$http.post('/sys/plat/task/accept/audit',this.auditDiaItemList.map((item)=>{return {id:item.id,result:result,reason:this.auditFormData.reason}})).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg)
			}
			this.auditDiaCancel();
			this.$message({
			  message: this.$t('prompt.success'),
			  type: 'success',
			  duration: 1500,
			  onClose: () => {
				this.query()
			  }
			})
		  }).catch(()=>{})
		}).catch(()=>{})
	  },
	  //删除任务
	  delTask(id){
		this.$confirm(this.$t('prompt.info', { 'handle': '删除任务'}), this.$t('prompt.title'), {
		  confirmButtonText: this.$t('confirm'),
		  cancelButtonText: this.$t('cancel'),
		  type: 'warning'
		}).then(()=>{
		  this.$http.post('/sys/plat/task/accept/delete',[id]).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg)
			}
			this.$message({
				message: this.$t('prompt.success'),
				type: 'success',
				duration: 1500,
				onClose: () => {
				  this.query()
				}
			})
		  }).catch(()=>{})
		}).catch(()=>{})
	  },
	  //上传文件自定义函数
	  fileUpload(file){
		let form = new FormData();
		form.append('file',file.file);
		console.log(form);
		this.$http.post('/oss/file/upload2',form).then(({ data: res })=>{
		  console.log(res);
		  if (res.code !== 0) {
			return this.$message.error(res.msg);
		  }
		  this.fileList.push({name:'',url:res.data.url});
		}).catch((err)=>{
		})
	  },
	  //上传文件后将文件地址绑定任务
	  fileBindTask(){
		let data;
		let url = "/sys/plat/task/accept"
		if(this.uploadType == '1'){
		  data = {
			id:this.uploadFileItem.id,
			finishProofPath:this.fileList.map(item=>{return item.url}).join(','),
		  }
		}else if(this.uploadType == '2'){
		  data = {
			id:this.uploadFileItem.id,
			finishProofPath2:this.fileList.map(item=>{return item.url}).join(','),
		  }
		}else if(this.uploadType == '3'){
		   data = {
			platTaskAcceptIdList:this.dataListSelections.map((item)=>{return item.id}),
			finishProofPath2:this.fileList.map(item=>{return item.url}).join(','),
		  }
		  url = '/sys/plat/task/accept/saveFinishProofPath2'
		}
		if(this.uploadType != '3'){
		  this.$http.put(url,data).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg);
			}
			this.uploadDialog = false;
			this.fileList = [];
			this.uploadType = "";
			this.query();
		  })
		}else{
		  this.$http.post(url,data).then(({ data: res })=>{
			if (res.code !== 0) {
			  return this.$message.error(res.msg);
			}
			this.uploadDialog = false;
			this.fileList = [];
			this.uploadType = "";
			this.query();
		  })
		}
		
	  },
	  //打开单个上传文件
	  openUploadDia(row,type){
		this.uploadFileItem = row;
		this.uploadType = type;
		console.log(this.uploadType)
  
		let fileList ;
		if(type == '1'){
		  fileList = row.finishProofPath?row.finishProofPath.split(','):[]
		}else if(type == '2'){
		  fileList = row.finishProofPath2?row.finishProofPath2.split(','):[]
		}
		this.fileList = fileList.map(item=>{
		  return {
			name:'',
			url:item
		  }
		});
		this.uploadDialog = true;
	  },
	  openBatchUploadDia(){
		if(!this.dataListSelections.length){
		  this.$message({
			message: '请选择批量上传完工证明的信息！',
			type: 'error',
			duration: 1500,
		  })
		  return
		}
		this.uploadType = '3';
		this.fileList = [];
		this.uploadDialog = true;
	  },
	  handlePictureCardPreview(file){
		this.previewPicDialog = true;
		this.dialogImageUrl = file.url;
	  },
	  handleRemove(file){
		this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			this.$message({
			  type: 'success',
			  message: '删除成功!'
			});
			var index = this.fileList.findIndex((value, index, arr) =>{
			  return value.url == file.url
			});
			if( index!= -1){
			  this.fileList.splice(index,1);
			}
		  }).catch(() => {
			this.$message({
			  type: 'info',
			  message: '已取消删除'
			});          
		  });
		
	  },
	  auditDiaCancel(){
		this.auditDia = false;
		this.auditDiaItemList = [];
		this.auditFormData = {
		  reason:''
		}
	  },
	  uploadClose(){
		this.uploadFileItem = null;
		this.uploadDialog = false;
		this.fileList = [];
	  },
	  uploadDiaClose(done){
		this.uploadFileItem = null;
		this.fileList = [];
		done();
	  },
	  infoHandle(id) {
		localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			  // 路由参数
			  const routeParams = {
				  routeName: `${this.$route.name}__任务详情`,
				  title: `任务详情`,
				  path: 'plat/platttask-info',
				  params: {
					  id:id
				  }
			  }
			  // 动态路由
			  addDynamicRoute(routeParams, this.$router)
		  },
	  showPdf(url){
		if(url.split('.')[url.split('.').length-1].indexOf('pdf')>-1){
		  return true
		}else{
		  return false
		}
		
	  },
	  showZip(url){
		if(url.split('.')[url.split('.').length-1].indexOf('zip')>-1 || url.split('.')[url.split('.').length-1].indexOf('rar')>-1){
		  return true
		}else{
		  return false
		}
	  },
	  zipPreview(url){
		window.open(url)
	  },
	  pdfPreview(url){
		window.open(url)
	  },
	}
  }
  </script>
  <style lang="scss">
  .el-upload-list-wrap-my  .el-upload-list--picture-card{
	  margin: 0;
	  display: inline;
	  vertical-align: top;
	  }
  .el-upload-list-wrap-my .el-upload-list__item:first-child{
	margin-top: 0px !important;
  }
  .imgHide .el-upload--picture-card {
	display: none;
  }
  .uploadimgage{
	text-align: center;
	margin-top: 5px;
  }
  
  .mod-plat__plattaskaccept {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 190px);
    
    .el-form {
      flex-shrink: 0;
    }
    
    .el-table {
      flex: 1;
      margin-top: 20px;
    }
    
    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
  </style>